import { render, staticRenderFns } from "./uv-type-configuration.modal.vue?vue&type=template&id=6ca6c157&"
import script from "./uv-type-configuration.modal.vue?vue&type=script&lang=ts&"
export * from "./uv-type-configuration.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports